import { useSyncExternalStore } from 'react'
import { useReducedMotion } from 'motion/react'

function subscribe(onChange: () => void) {
  document.addEventListener('visibilitychange', onChange)
  return () => document.removeEventListener('visibilitychange', onChange)
}

/** The page is on screen (`document.visibilityState`); on the server, or without the API, it counts as visible. */
export function usePageVisible(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => document.visibilityState !== 'hidden',
    () => true,
  )
}

/**
 * What a public waiting moment may do: `motion`, play a one-off motion (motion is welcome: not reduced); `loops`, run
 * a loop too (motion is welcome and the page is on screen, so a tab left in the background isn't kept busy). Under
 * reduced motion nothing moves (the theme's motion tokens become 0 ms, and a loop at zero would flicker).
 */
export function useLoopsAllowed(): { motion: boolean; loops: boolean } {
  const reduced = Boolean(useReducedMotion())
  const visible = usePageVisible()
  return { motion: !reduced, loops: !reduced && visible }
}
